// SendAudioModal.js
import React, { useState, useEffect } from 'react';

const SendAudioModal = ({ isOpen, onClose, phoneNumber, message, onConfirmSend, tipoMensagem, messageId }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [serverAudioUrl, setServerAudioUrl] = useState(null); // Armazena a URL retornada pelo servidor
  const [serverMessage, setServerMessage] = useState(''); // Armazena a mensagem retornada pelo servidor
  const [mediaRecorder, setMediaRecorder] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setAudioUrl(null);
      setServerAudioUrl(null);
      setServerMessage('');
    }
  }, [isOpen, phoneNumber]);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    const audioChunks = [];

    recorder.ondataavailable = event => audioChunks.push(event.data);
    recorder.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
      setAudioUrl(URL.createObjectURL(audioBlob));
    };

    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);
  };

  const stopRecording = () => {
    mediaRecorder.stop();
    setIsRecording(false);
  };

  const handleAudioSend = async () => {
    if (audioUrl) {
      const audioBlob = await fetch(audioUrl).then(r => r.blob());
      const formData = new FormData();
      formData.append('audio', audioBlob);
      formData.append('messageId', messageId);

      const response = await fetch('https://api2.apploja.com/smssender/uploadaudio.php', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: formData,
      });

      const result = await response.json();
      if (response.ok && result.success) {
        setServerAudioUrl(result.url);
        setServerMessage(result.message);
        alert("Áudio enviado com sucesso!");

        // Confirma o envio automaticamente após o upload bem-sucedido
        await onConfirmSend(phoneNumber, messageId); // Envia o id da mensagem na confirmação
        onClose(); // Fecha o modal após a confirmação e exibe o próximo contato no ContactList
      } else {
        alert("Erro ao enviar o áudio: " + (result.error || "Erro desconhecido"));
      }

      setAudioUrl(null);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end">
      <div className="bg-white w-full max-w-md p-6 rounded-t-lg shadow-lg relative">
        <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-sm rounded-lg" onClick={onClose}>✕</button>
        
        {tipoMensagem === 3 && (
          <div>
            <p className="text-center">{message}</p>
            {isRecording ? (
              <button className="bg-red-500 text-white w-full py-2 rounded-lg" onClick={stopRecording}>Parar Gravação</button>
            ) : (
              <button className="bg-blue-500 text-white w-full py-2 rounded-lg" onClick={startRecording}>Gravar Áudio</button>
            )}

            {audioUrl && (
              <>
                <audio controls src={audioUrl} className="w-full mt-2"></audio>
                <button className="bg-green-500 text-white w-full py-2 rounded-lg mt-2" onClick={handleAudioSend}>Enviar Áudio</button>
              </>
            )}

            {serverAudioUrl && (
              <div className="mt-4">
                <p className="text-green-600">Mensagem do servidor: {serverMessage}</p>
                <p>URL do áudio enviado: <a href={serverAudioUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500">{serverAudioUrl}</a></p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SendAudioModal;
